import type {
  VoiceCallAggregatesResponse,
  VoiceCallAggregatesResult,
  VoicePartnerCallAggregateSummary,
} from '@reach/shared-types/voice-agent-calls';
import { partnerApi, type ApiResponse } from '../../lib/api';
import { API_ENDPOINTS } from '../../lib/constants';

export type {
  VoiceCallAggregatesResult,
  VoicePartnerCallAggregateSummary,
  VoiceTenantCallAggregate,
} from '@reach/shared-types/voice-agent-calls';

export async function fetchVoiceCallAggregates(options?: {
  cursor?: string;
  limit?: number;
  startDate?: string;
  endDate?: string;
}): Promise<VoiceCallAggregatesResult> {
  const params = new URLSearchParams();
  if (options?.cursor) params.append('cursor', options.cursor);
  if (options?.limit) params.append('limit', options.limit.toString());
  if (options?.startDate) params.append('startDate', options.startDate);
  if (options?.endDate) params.append('endDate', options.endDate);

  const queryString = params.toString();
  const url = queryString
    ? `${API_ENDPOINTS.PARTNER.VOICE_CALL_AGGREGATES}?${queryString}`
    : API_ENDPOINTS.PARTNER.VOICE_CALL_AGGREGATES;

  const response = await partnerApi.request<ApiResponse<VoiceCallAggregatesResponse>>(url);
  const payload = response.data;
  if (!payload) {
    throw new Error('Voice call aggregates response missing data');
  }
  return {
    data: payload.results,
    hasNextPage: payload.pagination.hasNextPage,
    cursor: payload.pagination.cursor ?? undefined,
  };
}

export async function fetchPartnerVoiceCallAggregateSummary(options?: {
  startDate?: string;
  endDate?: string;
}): Promise<VoicePartnerCallAggregateSummary> {
  const params = new URLSearchParams();
  if (options?.startDate) params.append('startDate', options.startDate);
  if (options?.endDate) params.append('endDate', options.endDate);

  const queryString = params.toString();
  const url = queryString
    ? `${API_ENDPOINTS.PARTNER.VOICE_CALL_AGGREGATES_SUMMARY}?${queryString}`
    : API_ENDPOINTS.PARTNER.VOICE_CALL_AGGREGATES_SUMMARY;

  const response = await partnerApi.request<ApiResponse<VoicePartnerCallAggregateSummary>>(url);
  const payload = response.data;
  if (!payload) {
    throw new Error('Voice call aggregate summary response missing data');
  }
  return payload;
}
